import { get, writable } from 'svelte/store';

export interface LibraryStateValue {
    id: string;
    type: string;
    inFavorites: boolean;
    inLibrary: boolean;
}

type LibraryState = Map<string, LibraryStateValue>;

const libraryStateStore = writable<LibraryState>(new Map());
const updated = writable(Symbol());

export function subscribeToId(
    id: string,
    callback: (value: LibraryStateValue) => void,
): () => void {
    return updated.subscribe(() => {
        const value = get(libraryStateStore).get(id);
        if (value) {
            callback(value);
        }
    });
}

export function setLibraryStates(values: LibraryStateValue[]): void {
    values.forEach((value) => {
        if (value) {
            setLibraryState(value.id, value, true);
        }
    });
    updated.update(() => Symbol());
}

export function setLibraryState(
    id: string,
    value: LibraryStateValue,
    batchSet: boolean = false,
): void {
    libraryStateStore.update((currentState) => {
        currentState.set(id, value);
        return currentState;
    });

    if (!batchSet) {
        updated.update(() => Symbol());
    }
}

export function updateLibraryState(
    id: string,
    value: {
        id: string;
        type: string;
        inLibrary?: boolean;
        inFavorites?: boolean;
    },
): void {
    libraryStateStore.update((currentState) => {
        currentState.set(id, { ...currentState.get(id), ...value });
        return currentState;
    });
    updated.update(() => Symbol());
}

export function getLibraryState(id: string): LibraryStateValue | undefined {
    return get(libraryStateStore).get(id);
}

export function clear(): void {
    libraryStateStore.set(new Map());
    updated.set(Symbol());
}
